import { render } from "./TemplateReport.vue?vue&type=template&id=243e6124&scoped=true"
import script from "./TemplateReport.vue?vue&type=script&lang=js"
export * from "./TemplateReport.vue?vue&type=script&lang=js"

import "./TemplateReport.vue?vue&type=style&index=0&id=243e6124&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243e6124"]])

export default __exports__